export enum AgentsTransfersLoaders {
    isAgentsTransfersLoading
}
